import { Environment } from './env.type';
import { baseEnvironment } from './base';

export const environment: Environment = {
    ...baseEnvironment,
    envName: 'development',
    graphqlUrl: 'https://api.dev.mdovisio.com.br/graphql', // #DEV
    // graphqlUrl: 'https://api.mdovisio.com.br/graphql', // #PROD
    // graphqlUrl: 'http://0.0.0.0:3075/graphql', // #LOCAL
};
